
export default {
  props: {
    options: {type: Array, required: true}
  },
  emits: ['answer-ai'],
  data() {
    return {
      selected_idx: -1
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onGlobalKeydown)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onGlobalKeydown)
  },
  methods: {
    onGlobalKeydown(ev) {
      if (ev.defaultPrevented || ev.ctrlKey || ev.metaKey || ev.altKey) return
      if (this.selected_idx !== -1) return

      const option_idx = Number(ev.key) - 1
      if (!Number.isInteger(option_idx) || option_idx < 0 || option_idx >= this.options.length) return
      
      ev.preventDefault()
      ev.stopPropagation()
      this.onAccept(option_idx)
    },
    onAccept(idx){
      this.selected_idx = idx
      const selection = this.options[idx]
      this.$emit('answer-ai', selection)
    },
  }
}
